/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all tools`)
};

const es_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las herramientas`)
};

const de_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Werkzeuge anzeigen`)
};

const nl_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk alle tools`)
};

const fr_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tous les outils`)
};

const it_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza tutti gli strumenti`)
};

const pt_br2_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as ferramentas`)
};

const pt_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as ferramentas`)
};

const ja_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのツールを見る`)
};

const zh_nav_view_all_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_view_all_tools = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_view_all_tools(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nav_view_all_tools", locale)
	if (locale === "en") return en_nav_view_all_tools(inputs)
	if (locale === "es") return es_nav_view_all_tools(inputs)
	if (locale === "de") return de_nav_view_all_tools(inputs)
	if (locale === "nl") return nl_nav_view_all_tools(inputs)
	if (locale === "fr") return fr_nav_view_all_tools(inputs)
	if (locale === "it") return it_nav_view_all_tools(inputs)
	if (locale === "pt-BR") return pt_br2_nav_view_all_tools(inputs)
	if (locale === "pt") return pt_nav_view_all_tools(inputs)
	if (locale === "ja") return ja_nav_view_all_tools(inputs)
	return zh_nav_view_all_tools(inputs)
};